{
  "app.title": "eTTS — Test Token Server",
  "nav.dashboard": "Dashboard",
  "nav.tokens": "Tokens",
  "nav.logs": "Logs",
  "nav.transactionLogs": "Transaction logs",
  "nav.serverStats": "Server statistics",
  "nav.settings": "Settings",
  "nav.docs": "Help",
  "nav.signOut": "Sign out",
  "header.settings": "Settings",
  "header.notifications": "Notifications",
  "header.account": "Account",
  "notifications.title": "Notifications",
  "notifications.empty": "No notifications.",
  "theme.label": "Appearance",
  "theme.system": "System",
  "theme.light": "Light",
  "theme.dark": "Dark",
  "theme.switchToDark": "Switch to dark theme",
  "theme.switchToLight": "Switch to light theme",
  "login.title": "Sign in",
  "login.subtitle": "Sign in to the eTTS administration",
  "login.username": "Username",
  "login.password": "Password",
  "login.submit": "Sign in",
  "login.error": "Invalid username or password.",
  "login.loggedOut": "You have been signed out.",
  "login.expired": "Your session has expired. Please sign in again.",
  "dashboard.title": "Dashboard",
  "dashboard.welcome": "Welcome to the eTTS administration.",
  "dashboard.tokensTotal": "Tokens total",
  "dashboard.tokensActive": "Active",
  "dashboard.tokensDeleted": "Deleted",
  "dashboard.tokensActivating": "Activating",
  "dashboard.tokensFailed": "Failed",
  "dashboard.authServerDistribution": "Auth Server Distribution",
  "dashboard.noData": "No data",
  "dashboard.systemStats": "System Statistics",
  "dashboard.systemStats.transactions": "Total Transactions",
  "dashboard.systemStats.activationEvents": "Activation Events",
  "dashboard.systemStats.commLogs": "Communication Logs",
  "dashboard.quickActions": "Quick Actions",
  "dashboard.quick.viewTokens": "View All Tokens",
  "dashboard.quick.testActivation": "Test Activation",
  "dashboard.quick.apiDocs": "API Documentation",
  "dashboard.quick.health": "Health Check",
  "tokens.title": "Tokens",
  "tokens.subtitle": "List of tokens managed by this server.",
  "tokens.col.tokenId": "Token ID",
  "tokens.col.username": "User",
  "tokens.col.state": "State",
  "tokens.col.connector": "Connector",
  "tokens.col.created": "Created",
  "tokens.backToList": "Back to list",
  "tokens.field.licenceId": "Licence ID",
  "tokens.field.instanceSeq": "Instance",
  "tokens.field.activationGuid": "Activation GUID",
  "tokens.field.activated": "Activated",
  "tokens.field.updated": "Updated",
  "tokens.field.activationEvents": "Activation events",
  "tokens.field.keyStorageFormat": "Key storage mode",
  "tokens.keyStorageFormat.ETTS": "ETTS",
  "tokens.keyStorageFormat.ETTS.hint": "cheap password-derived key — the performance-testing mode",
  "tokens.keyStorageFormat.SECURE": "SECURE",
  "tokens.keyStorageFormat.SECURE.hint": "Argon2id — full storage encryption, markedly slower activation",
  "tokens.keyStorageFormat.unrecorded": "not recorded — the token predates this field",
  "tokens.field.expires": "Expires",
  "tokens.field.tags": "Tags",
  "tokens.connectorAttributes": "Connector attributes",
  "logs.title": "Logs",
  "logs.subtitle": "Auth server communication logs and application log (auto-refresh 10 s).",
  "logs.tab.comm": "Communication",
  "logs.tab.app": "Application",
  "logs.detailTitle": "Log #{{id}}",
  "logs.errorsOnly": "Errors only (4xx+5xx)",
  "logs.from": "From",
  "logs.to": "To",
  "logs.rowsShown": "shown",
  "logs.tokenId": "Token ID",
  "logs.statusFrom": "Status from",
  "logs.statusTo": "Status to",
  "logs.records": "Records",
  "logs.headerFilters": "Filter by headers",
  "logs.addHeader": "Add header",
  "logs.filter": "Filter",
  "logs.reset": "Reset",
  "logs.autoRefresh": "Auto-refresh:",
  "logs.results": "results",
  "logs.includeDetails": "Include details",
  "logs.page": "Page",
  "logs.total": "total",
  "logs.copy": "Copy",
  "logs.col.server": "Server",
  "logs.col.token": "Token",
  "logs.app.lines": "Lines",
  "logs.app.level": "Level",
  "logs.app.filter": "Filter",
  "logs.app.load": "Load",
  "logs.app.download": "Download",
  "logs.app.autoScroll": "Auto-scroll",
  "logs.app.lineCount": "{{count}} lines (buffer {{max}})",
  "logs.copyCurl": "Copy as cURL",
  "logs.copyJson": "Copy JSON",
  "logs.copied": "Copied",
  "logs.copyFail": "Copy failed",
  "logs.reqHeaders": "Request headers",
  "logs.reqBody": "Request body",
  "logs.resHeaders": "Response headers",
  "logs.resBody": "Response body",
  "logs.col.direction": "Direction",
  "logs.col.method": "Method",
  "logs.col.endpoint": "Endpoint",
  "logs.col.status": "Status",
  "logs.allLevels": "All",
  "logs.empty": "No records.",
  "txlogs.title": "Transaction logs",
  "txlogs.subtitle": "Audit of transaction approvals and rejections.",
  "txlogs.col.created": "Time",
  "txlogs.col.operation": "Operation",
  "txlogs.col.result": "Result",
  "txlogs.col.duration": "Duration",
  "txlogs.ok": "OK",
  "txlogs.fail": "Failed",
  "pager.pageInfo": "Page {{page}} of {{pages}} · {{total}} records",
  "pager.prev": "Previous",
  "pager.next": "Next",
  "txlogs.stat.total": "Total operations",
  "txlogs.stat.success": "Successful",
  "txlogs.stat.last24h": "Last 24 h",
  "txlogs.stat.successRate": "Success rate",
  "txlogs.stat.failed": "Failed",
  "txlogs.stat.approves": "Approves",
  "txlogs.stat.rejects": "Rejects",
  "txlogs.stat.avgDuration": "Avg duration",
  "txlogs.filter.from": "From",
  "txlogs.filter.to": "To",
  "pager.pageSize": "Page size",
  "txlogs.filter.autoRefresh": "Auto-refresh",
  "txlogs.filter.off": "Off",
  "txlogs.filter.live": "live",
  "txlogs.col.txId": "Transaction ID",
  "pager.first": "First",
  "pager.last": "Last",
  "txlogs.field.authServerTxId": "Auth Server TX ID",
  "txlogs.field.paatProfile": "PAAT profile",
  "txlogs.field.deviceAuthType": "Device Auth Type",
  "txlogs.field.createdAt": "Created",
  "txlogs.field.startedAt": "Started",
  "txlogs.field.completedAt": "Completed",
  "txlogs.field.traceId": "Trace ID",
  "txlogs.field.errorCode": "Error Code",
  "txlogs.field.correlationId": "Correlation ID",
  "txlogs.field.requestIp": "Request IP",
  "txlogs.field.userAgent": "User-Agent",
  "txlogs.field.mobileSdkData": "Mobile SDK Data",
  "txlogs.field.scmsHash": "SCMS Hash",
  "txlogs.detailTitle": "Transaction log #{{id}}",
  "txlogs.field.transactionId": "Transaction ID",
  "txlogs.field.signature": "Signature",
  "txlogs.field.signatureValue": "Signature value",
  "txlogs.field.encryptedHash": "Encrypted data hash",
  "txlogs.field.password": "Password",
  "txlogs.field.rejectionReason": "Rejection reason",
  "txlogs.field.wysiwyg": "WYSIWYS data",
  "txlogs.field.decrypted": "Decrypted data",
  "stats.title": "Server statistics",
  "stats.subtitle": "Live server metrics (refreshed every 5 s).",
  "stats.rps": "Requests/s",
  "stats.lastUpdate": "Last update",
  "stats.manual": "Manual",
  "stats.refreshNow": "Refresh now",
  "stats.processCpu": "Process CPU",
  "stats.systemCpu": "System CPU",
  "stats.gcLastPause": "GC last pause",
  "stats.totalReq": "total",
  "stats.errorRate": "Error rate",
  "stats.heap": "Heap memory",
  "stats.throughputHistory": "Throughput history",
  "stats.throughput": "Request throughput",
  "stats.last1m": "Last 1 min",
  "stats.last5m": "Last 5 min",
  "stats.last1h": "Last 1 h",
  "stats.latency": "Latency percentiles",
  "stats.latencyTotal": "Total latency",
  "stats.latencyConnector": "Connector latency",
  "stats.latencyProcessing": "Processing latency",
  "stats.minMaxAvg": "min / max / avg",
  "stats.errors": "Errors",
  "stats.recentErrors": "Recent errors",
  "stats.noErrors": "No recent errors.",
  "stats.dbPool": "Database pool",
  "stats.httpPool": "HTTP pool",
  "stats.jvm": "JVM",
  "stats.active": "Active",
  "stats.idle": "Idle",
  "stats.waiting": "Waiting",
  "stats.utilization": "Utilization",
  "stats.leased": "Leased",
  "stats.available": "Available",
  "stats.pending": "Pending",
  "stats.threads": "Threads",
  "stats.nonHeap": "Non-heap",
  "settings.title": "Settings",
  "settings.subtitle": "Server, connector and access configuration",
  "settings.group.overview": "Overview",
  "settings.group.system": "System",
  "settings.group.operations": "Operations",
  "settings.group.access": "Access",
  "settings.group.appearance": "Appearance",
  "settings.users": "Users",
  "settings.connectors": "Connectors",
  "settings.maintenance": "Maintenance",
  "settings.general": "General",
  "settings.audit": "Audit",
  "settings.tls": "TLS",
  "tls.title": "TLS",
  "tls.subtitle": "TLS status and operations (certificate is changed via env variables)",
  "tls.status": "Status",
  "tls.https": "HTTPS active",
  "tls.plainHttp": "Plain HTTP",
  "tls.protocols": "Protocols",
  "tls.listenPort": "Listen port",
  "tls.httpPort": "HTTP port",
  "tls.httpsPublicPort": "Public HTTPS port",
  "tls.allowHttp": "Allow HTTP",
  "tls.redirectHttp": "HTTP→HTTPS redirect",
  "tls.forwardHeaders": "Forward headers",
  "tls.keystore": "Keystore",
  "tls.acmeDomains": "ACME domains",
  "tls.renewalDays": "Renewal (days before expiry)",
  "tls.reload": "Reload bundle",
  "tls.renew": "Renew certificate (ACME)",
  "tls.activeCert": "Active certificate",
  "tls.subject": "Subject",
  "tls.issuer": "Issuer",
  "tls.validity": "Validity",
  "tls.serial": "Serial",
  "tls.fingerprint": "Fingerprint",
  "tls.history": "Certificate history",
  "tls.installed": "Installed",
  "tls.expires": "Expires",
  "tls.source": "Source",
  "tls.activeCol": "Active",
  "tls.notes": "Notes",
  "tls.enableHintTitle": "TLS is not active (running plain HTTP)",
  "tls.enableHint": "Set ETTS_TLS_SOURCE=keystore for direct TLS, or terminate TLS at a reverse proxy and set SERVER_FORWARD_HEADERS_STRATEGY=framework. See the env reference below.",
  "audit.title": "Auth audit log",
  "audit.subtitle": "Logins, user management and security events",
  "audit.search": "Search",
  "audit.empty": "No audit events",
  "audit.detailTitle": "Audit event detail",
  "audit.details": "Details",
  "audit.copy": "Copy",
  "audit.time": "Time",
  "audit.event": "Event",
  "audit.eventGroups": "Groups",
  "audit.group.login": "Login",
  "audit.group.password": "Passwords",
  "audit.group.users": "Users",
  "audit.group.apiKeys": "API keys",
  "audit.group.security": "Security",
  "audit.outcome": "Outcome",
  "audit.actor": "Actor",
  "audit.ip": "IP address",
  "audit.target": "Target",
  "account.title": "Account",
  "account.subtitle": "Your profile and password change",
  "account.username": "Username",
  "account.displayName": "Display name",
  "account.email": "Email",
  "account.roles": "Roles",
  "account.authSource": "Auth source",
  "account.bootstrap": "Bootstrap admin",
  "account.mustChange": "Must change password",
  "account.ldapNote": "This account authenticates against an external directory (LDAP). Change your password there.",
  "account.changePassword": "Change password",
  "account.locked.title": "Password change is locked for this deployment",
  "account.locked.detail": "The User Management feature (admin.user-management) is not enabled in your license tier, so the in-app password change form is disabled.",
  "account.locked.bootstrapIntro": "You are signed in as the bootstrap admin. To rotate this account's password:",
  "account.locked.bootstrapStep1": "Update ETTS_INITIAL_ADMIN_PASSWORD in your environment.",
  "account.locked.bootstrapStep2": "Make sure ETTS_BOOTSTRAP_SYNC_PWD=true (default in docker-compose.yml).",
  "account.locked.bootstrapStep3": "Restart the application — the bootstrap admin password is re-synced on startup.",
  "account.locked.nonbootstrap": "Ask an administrator with shell access to rotate your password, or upgrade the license to enable user management.",
  "account.advertised.title": "Password self-service is coming soon",
  "account.advertised.detail": "The User Management feature is advertised for a future release of your tier. Until it ships, your password lives in the env-supplied bootstrap configuration; see ETTS_INITIAL_ADMIN_PASSWORD.",
  "account.current": "Current password",
  "account.new": "New password",
  "account.confirm": "Confirm password",
  "account.save": "Change password",
  "account.changed": "Password changed.",
  "account.mismatch": "New password and confirmation do not match.",
  "account.tooShort": "Password must be at least 12 characters long.",
  "settings.tokenSettings": "Token Settings",
  "settings.uiSettings": "UI Settings",
  "settings.appearance": "Appearance",
  "appearance.title": "Appearance",
  "appearance.subtitle": "Choose the application theme. The theme is saved in this browser, the language to your account.",
  "appearance.system": "System",
  "appearance.system.desc": "Match system setting",
  "appearance.light": "Light",
  "appearance.light.desc": "Always light theme",
  "appearance.dark": "Dark",
  "appearance.dark.desc": "Always dark theme",
  "common.confirm": "Confirm",
  "tokenSettings.title": "Token Settings",
  "tokenSettings.subtitle": "Instance mode (single/multiple active instances per licence)",
  "tokenSettings.currentMode": "Current mode",
  "tokenSettings.buildProfile": "Build profile",
  "tokenSettings.default": "Default",
  "tokenSettings.setSingle": "Switch to SINGLE",
  "tokenSettings.setMulti": "Switch to MULTI",
  "tokenSettings.switchTitle": "Change instance mode",
  "tokenSettings.switchSingleWarn": "Switching to SINGLE deactivates excess active instances per licence. Continue?",
  "tokenSettings.switchMultiInfo": "Switch to MULTI (multiple active instances per licence)?",
  "tokenSettings.cleanupDone": "Deactivated {{tokens}} tokens across {{licences}} licences.",
  "uiSettings.title": "UI Settings",
  "uiSettings.subtitle": "Navigation item visibility",
  "uiSettings.saved": "Saved",
  "uiSettings.showAll": "Show all",
  "uiSettings.hideAll": "Hide all",
  "uiSettings.resetDefaults": "Reset to defaults",
  "general.title": "General",
  "general.subtitle": "Runtime and HTTP client (read-only)",
  "general.runtime": "Runtime",
  "general.httpClient": "HTTP client",
  "general.noHttp": "No configuration",
  "general.envNote": "Configuration is changed via env variables at deployment.",
  "general.activeGlobalTls": "Active global TLS versions",
  "general.poolMonitorNote": "HttpPoolMonitor logs pool state every 60s; metrics are available via Prometheus (/actuator/prometheus).",
  "general.envReference": "Connection-pool env variables",
  "general.env.poolMaxTotal": "Max total pooled connections",
  "general.env.poolMaxPerRoute": "Max connections per route",
  "general.env.connectTimeout": "Connect timeout (ms)",
  "general.env.readTimeout": "Read timeout (ms)",
  "general.env.tlsVersions": "Outbound TLS versions",
  "tls.envReference": "TLS env variables",
  "tls.env.source": "TLS source (none / keystore / acme)",
  "tls.env.hsts": "Enable HSTS header",
  "tls.env.httpsPort": "Public HTTPS port",
  "tls.env.allowHttp": "Allow plain HTTP alongside HTTPS",
  "tls.env.forwardHeaders": "Forwarded-headers strategy (reverse proxy)",
  "maintenance.title": "Maintenance",
  "maintenance.subtitle": "Statistics, data cleanup, backups and token export/import",
  "maintenance.stats": "Database statistics",
  "maintenance.refreshStats": "Refresh statistics",
  "maintenance.schedulers": "Scheduled tasks",
  "maintenance.autoCleanupScheduler": "Automatic log cleanup",
  "maintenance.tokenExpirationScheduler": "Token expiration",
  "maintenance.enabled": "Enabled",
  "maintenance.retentionDays": "Retention (days)",
  "maintenance.lastRun": "Last run",
  "maintenance.httpLogs": "HTTP logs",
  "maintenance.txLogs": "Transaction logs",
  "maintenance.tokensTotal": "Tokens total",
  "maintenance.tokensActive": "Active tokens",
  "maintenance.cleanupHttp": "HTTP communication logs cleanup",
  "maintenance.cleanupTx": "Transaction logs cleanup",
  "maintenance.cleanupActivationEvents": "Activation events cleanup",
  "maintenance.cleanupTokens": "Token cleanup",
  "maintenance.olderThanDays": "Older than (days)",
  "maintenance.olderThanDaysOpt": "Older than (days, optional)",
  "maintenance.preview": "Preview",
  "maintenance.delete": "Delete",
  "maintenance.wouldDelete": "To delete: {{count}} records",
  "maintenance.deleted": "Deleted: {{count}} records",
  "maintenance.cleanupConfirm": "Delete records older than {{days}} days?",
  "maintenance.tokenCleanupConfirm": "Delete tokens in states: {{states}}? Related transactions are cascade-deleted.",
  "maintenance.backups": "Database backups",
  "maintenance.createBackup": "Create backup",
  "maintenance.noBackups": "No backups",
  "maintenance.restore": "Restore",
  "maintenance.restoreConfirm": "Restore database from backup {{filename}}? This OVERWRITES all current data.",
  "maintenance.deleteBackupConfirm": "Delete backup {{filename}}?",
  "maintenance.exportImport": "Token export / import",
  "maintenance.export": "Export",
  "maintenance.import": "Import",
  "maintenance.includePasswords": "Include passwords",
  "maintenance.activeCascadeWarning": "Deleting ACTIVE tokens cascades — related data will be removed. Dangerous!",
  "maintenance.includeActivationEvents": "Include activation events",
  "maintenance.exportBtn": "Export",
  "maintenance.overwrite": "Overwrite existing",
  "maintenance.importBtn": "Import",
  "maintenance.importPreview": "Total {{total}} · new {{fresh}} · existing {{existing}}",
  "maintenance.imported": "Updated {{updated}} · skipped {{skipped}} · failed {{failed}}",
  "maintenance.dangerZone": "Danger zone",
  "maintenance.fullReset": "Full DB reset",
  "maintenance.fullResetDesc": "Deletes ALL data from the database. Development/testing only.",
  "maintenance.fullResetConfirm": "Really delete ALL data? Irreversible.",
  "maintenance.typeReset": "Type RESET to confirm:",
  "connectors.title": "Connectors",
  "connectors.reset": "Reset",
  "connectors.resetConfirm": "Reset connector {{type}} to default configuration? This overwrites current settings.",
  "connectors.editHint": "Empty/masked (****) credential values are preserved on save.",
  "connectors.enabledLabel": "Connector enabled",
  "connectors.enable": "Enable connector",
  "connectors.disable": "Disable connector",
  "connectors.credentials": "Credentials",
  "connectors.tabGeneral": "General",
  "connectors.configJson": "Configuration (JSON)",
  "connectors.credsJson": "Credentials (JSON)",
  "connectors.credsHint": "Keep **** or empty to preserve the existing secret.",
  "connectors.invalidConfigJson": "Invalid JSON in configuration.",
  "connectors.invalidCredsJson": "Invalid JSON in credentials.",
  "connectors.subtitle": "Auth server status and connection test.",
  "connectors.none": "No connectors available.",
  "connectors.enabled": "Enabled",
  "connectors.disabled": "Disabled",
  "connectors.test": "Test connection",
  "connectors.testing": "Testing…",
  "connectors.enableFirst": "Enable connector first",
  "connectors.config": "Configuration",
  "connectors.ok": "Connection works",
  "connectors.fail": "Connection failed",
  "connectors.route": "Route",
  "connectors.route.direct": "direct",
  "connectors.route.proxy": "via proxy {{target}}",
  "connectors.degraded": "Someone other than the target server answered",
  "connectors.detail.PROBE_ENDPOINT_UNAVAILABLE": "The gateway answered {{status}} — the probe endpoint is not available in this environment",
  "connectors.detail.REQUIRES_AUTHENTICATION": "The server answered, the endpoint requires authentication",
  "connectors.detail.NOT_FROM_TARGET_SERVER": "The response did not come from the target server — most likely returned by a proxy",
  "settings.apiKeys": "API keys",
  "apikeys.title": "API keys",
  "apikeys.subtitle": "API clients and their keys for programmatic access.",
  "apikeys.usage.intro": "Send the key in the Authorization header using the ApiKey scheme:",
  "apikeys.usage.notBearer": "The Bearer scheme is reserved for JWTs from /api/v1/auth/login — a key sent as Bearer returns 401 regardless of its roles and scopes.",
  "apikeys.usage.help": "Details in the help center",
  "apikeys.usage.modalHint": "Send it in the Authorization header using the ApiKey scheme (not Bearer).",
  "apikeys.addClient": "Add client",
  "apikeys.noClients": "No API clients.",
  "apikeys.enabled": "Active",
  "apikeys.disabled": "Inactive",
  "apikeys.addKey": "New key",
  "apikeys.noKeys": "No keys.",
  "apikeys.keys": "Keys",
  "apikeys.label": "Label",
  "apikeys.scopes": "Scopes",
  "apikeys.roles": "Roles",
  "apikeys.created": "Created",
  "apikeys.lastUsed": "Last used",
  "apikeys.revoked": "Revoked",
  "apikeys.active": "Active",
  "apikeys.revoke": "Revoke",
  "apikeys.name": "Name",
  "apikeys.description": "Description",
  "apikeys.nameRequired": "Enter a name.",
  "apikeys.newKey": "New API key",
  "apikeys.needScopeOrRole": "Select at least one role or scope.",
  "apikeys.ttl": "Validity (days)",
  "apikeys.ttlNever": "No expiry",
  "apikeys.generate": "Generate",
  "apikeys.copyNow": "Copy the key now — it won't be shown again.",
  "apikeys.copy": "Copy",
  "apikeys.deleteClientTitle": "Delete client",
  "apikeys.deleteClientConfirm": "Really delete client {{name}} and all its keys?",
  "common.delete": "Delete",
  "common.done": "Done",
  "settings.directory": "Directory (LDAP)",
  "directory.title": "Directory (LDAP)",
  "directory.subtitle": "Directory providers overview and connection test.",
  "directory.none": "No LDAP provider configured.",
  "directory.available": "Available",
  "directory.unavailable": "Unavailable",
  "directory.filter": "User filter",
  "directory.lastSuccess": "Last success",
  "directory.lastFailure": "Last failure",
  "directory.ok": "Connection works",
  "directory.fail": "Connection failed",
  "settings.license": "License",
  "license.title": "License",
  "license.subtitle": "License information and key activation.",
  "license.customer": "Customer",
  "license.tier": "Tier",
  "license.status": "Status",
  "license.valid": "Valid",
  "license.invalid": "Invalid",
  "license.validFrom": "Valid from",
  "license.validTo": "Valid to",
  "license.modules": "Active modules",
  "license.features": "Features",
  "license.enabled": "enabled",
  "license.advertised": "advertised",
  "license.locked": "locked",
  "license.featuresByModule": "Features by Module",
  "license.featuresCount": "features",
  "license.plannedFeatures": "Planned Features",
  "license.runtimeExpiry": "Runtime activation until",
  "license.activate": "Activate",
  "license.activateHint": "Enter a license key to unlock additional modules at runtime.",
  "license.keyRequired": "Enter a license key.",
  "license.activated": "License activated.",
  "license.activateFailed": "Activation failed.",
  "users.title": "Users",
  "users.subtitle": "Manage user accounts and roles.",
  "users.add": "Add user",
  "users.editTitle": "Edit user",
  "users.deleteTitle": "Delete user",
  "users.deleteConfirm": "Really delete user {{username}}? This cannot be undone.",
  "users.resetPassword": "Reset password",
  "users.newPassword": "New password",
  "users.edit": "Edit",
  "users.delete": "Delete",
  "users.enabled": "Enabled",
  "users.disabled": "Disabled",
  "users.enabledLabel": "Account enabled",
  "users.pwMin": "Password must be at least 12 characters.",
  "users.rolesMin": "Select at least one role.",
  "users.col.username": "Username",
  "users.col.displayName": "Display name",
  "users.col.roles": "Roles",
  "users.role.admin.desc": "Full access — manage users, connectors, tokens and settings.",
  "users.role.operator.desc": "Operational actions on tokens and transactions, without user management.",
  "users.role.viewer.desc": "Read-only — dashboards, logs and statistics.",
  "users.roles.hint": "Each role authority expands into multiple scopes.",
  "users.col.status": "Status",
  "users.col.source": "Source",
  "users.col.lockedUntil": "Locked until",
  "users.authSource": "Auth source",
  "users.externalId": "External identifier",
  "users.extIdRequired": "External identifier is required for LDAP.",
  "users.changeAuthSource": "Change auth source",
  "users.newPasswordOptional": "New password (optional)",
  "users.recentAudit": "Recent auth audit",
  "users.recentAudit.showAll": "View full audit log",
  "users.col.lastLogin": "Last login",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.loading": "Loading…",
  "common.loadError": "Failed to load data.",
  "testing.title": "Testing Tools",
  "testing.subtitle": "Interactive tools for verifying auth server integration",
  "testing.activation": "Activation",
  "testing.activation.title": "Token Activation Test",
  "testing.activation.subtitle": "Interactive tool with live progress monitoring",
  "testing.activation.params": "Test Parameters",
  "testing.activation.noAuthServers": "No supported connector is active",
  "testing.activation.start": "Start Test",
  "testing.activation.success": "Activation Successful",
  "testing.activation.failed": "Activation Failed",
  "testing.field.authServer": "Auth Server Type",
  "testing.field.username": "Username",
  "testing.field.otp": "OTP",
  "testing.field.password": "Password",
  "testing.field.activationGuid": "Activation GUID",
  "testing.field.expiresInSeconds": "Expires in (s)",
  "testing.field.expiresInSeconds.placeholder": "never expires",
  "testing.field.tags": "Tags",
  "testing.field.tags.placeholder": "comma-separated, e.g. smoke, loadtest",
  "testing.field.pushIdentifier": "Push Identifier (FCM token)",
  "testing.field.applicationId": "Application ID",
  "testing.field.deviceType": "Device Type",
  "testing.field.deviceType.hint": "Optional — default 34. Set only when testing alternative device codes.",
  "testing.field.paatProfile": "PAAT Profile (Device Info)",
  "testing.field.paatProfile.default": "-- Use Default Profile --",
  "testing.field.guidOptional": "Activation GUID (optional)",
  "testing.generate": "Generate",
  "testing.running": "Running…",
  "testing.connectorSpecific": "Connector-specific",
  "testing.progress": "Test Progress",
  "testing.httpCalls": "HTTP calls",
  "testing.httpLog": "HTTP Communication Log",
  "testing.viewToken": "View Token Detail",
  "testing.runAnother": "Run Another Test",
  "testing.exportJson": "Export (JSON)",
  "testing.exportCsv": "Export (CSV)",
  "testing.validation.required": "Please fill in all required fields",
  "testing.validation.appIdRequired": "Application ID is required for eCobra",
  "testing.validate.title": "Validate Activation (Get Bearer Token)",
  "testing.validate.submit": "Validate & Get Token",
  "testing.validate.running": "Validating…",
  "testing.validate.success": "Validation successful",
  "testing.validate.failed": "Validation failed",
  "testing.validate.copyFromMain": "Copy from main form",
  "testing.validate.copyToken": "Copy token",
  "testing.otp": "OTP / Password",
  "testing.otp.title": "OTP & Password Management Test",
  "testing.otp.subtitle": "OTP generation, password change and OTP verify with live progress",
  "testing.otp.scenario": "Scenario (pre-fill)",
  "testing.otp.scenarioNone": "-- Select scenario --",
  "testing.otp.mode": "Test Mode",
  "testing.otp.mode.OTP_GENERATION": "OTP Generation",
  "testing.otp.mode.PASSWORD_CHANGE": "Password Change",
  "testing.otp.mode.OTP_VERIFY": "OTP Verify",
  "testing.otp.tokenId": "Token ID",
  "testing.otp.tokenRequired": "Token ID is required",
  "testing.otp.currentPassword": "Current Password",
  "testing.otp.currentPwRequired": "Current password is required for OTP generation",
  "testing.otp.oldPassword": "Old Password",
  "testing.otp.newPassword": "New Password",
  "testing.otp.oldNewPwRequired": "Old and new password are required",
  "testing.otp.newPwMin": "New password must be at least 4 characters",
  "testing.otp.otpCode": "OTP Code",
  "testing.otp.otpRequired": "OTP code is required for verification",
  "testing.otp.start": "Start Test",
  "testing.otp.success": "Test Successful",
  "testing.otp.failed": "Test Failed",
  "testing.otp.generatedOtp": "Generated OTP",
  "testing.otp.expiresAt": "Expires At",
  "testing.otp.passwordChanged": "Password Changed",
  "testing.otp.otpValid": "OTP Valid",
  "testing.otp.help.generation": "Generate a new OTP code for the token (requires current password)",
  "testing.otp.help.passwordChange": "Change the token password (requires old and new password)",
  "testing.otp.help.verify": "Verify an OTP code on the auth server (eCobra or CSOB eChannels)",
  "testing.duration": "Duration",
  "testing.completedAt": "Completed At",
  "common.yes": "Yes",
  "common.no": "No",
  "testing.dr": "Device Replacement",
  "testing.dr.title": "Device Replacement Test",
  "testing.dr.subtitle": "Create → process (QR sequences) → complete workflow with live progress",
  "testing.dr.scenario": "Scenario (pre-fill)",
  "testing.dr.scenarioNone": "-- Select scenario --",
  "testing.dr.tokenId": "Token ID",
  "testing.dr.tokenRequired": "Token ID is required",
  "testing.dr.message": "Message (optional)",
  "testing.dr.autoProcess": "Auto-process after creation",
  "testing.dr.autoComplete": "Auto-complete (requires new activation GUID)",
  "testing.dr.simulateQrDelay": "Simulate QR scan delay",
  "testing.dr.qrDelayMs": "Delay (ms)",
  "testing.dr.start": "Start Test",
  "testing.dr.qrCodes": "QR Sequences",
  "testing.dr.qrSequence": "Sequence {{index}} of {{total}}",
  "testing.dr.qrHelp": "This would be displayed as a QR code on the original device",
  "testing.dr.success": "Device Replacement Test Successful",
  "testing.dr.completedWarn": "Completed with Warnings",
  "testing.dr.failed": "Test Failed",
  "testing.dr.errorType": "Error type",
  "testing.dr.stepsBeforeFailure": "Steps completed before failure",
  "testing.dr.originalTokenId": "Original Token ID",
  "testing.dr.transactionId": "Transaction ID",
  "testing.dr.qrSequenceCount": "QR Sequences",
  "testing.dr.newActivationGuid": "New Activation GUID",
  "testing.dr.newTokenId": "New Token ID",
  "testing.dr.stepsExecuted": "Steps Executed",
  "testing.dr.viewOriginal": "View Original Token",
  "testing.dr.viewNew": "View New Token",
  "testing.admin": "Admin Operations",
  "testing.admin.title": "Admin Operations Test",
  "testing.admin.subtitle": "Search, bulk deactivate, health check and log operations",
  "testing.admin.scenario": "Scenario (pre-fill)",
  "testing.admin.scenarioNone": "-- Select scenario --",
  "testing.admin.mode": "Test Mode",
  "testing.admin.mode.TOKEN_SEARCH": "Token Search",
  "testing.admin.mode.BULK_DEACTIVATE": "Bulk Deactivate",
  "testing.admin.mode.HEALTH_CHECK": "Health Check",
  "testing.admin.mode.LOG_EXPORT": "Log Export",
  "testing.admin.mode.LOG_STATISTICS": "Log Statistics",
  "testing.admin.mode.LOG_CLEANUP": "Log Cleanup",
  "testing.admin.help.search": "Search tokens with filters (username, state, auth server type)",
  "testing.admin.help.bulk": "Deactivate multiple tokens at once — DESTRUCTIVE operation",
  "testing.admin.help.health": "Check health of database and all auth server connections",
  "testing.admin.help.export": "Export communication logs to JSON or CSV",
  "testing.admin.help.stats": "Calculate statistics for communication logs",
  "testing.admin.help.cleanup": "Delete old logs (with optional dry run)",
  "testing.admin.any": "-- Any --",
  "testing.admin.usernameFilter": "Username Filter",
  "testing.admin.stateFilter": "State Filter",
  "testing.admin.authServerFilter": "Auth Server Type Filter",
  "testing.admin.maxResults": "Max Results",
  "testing.admin.tokenIds": "Token IDs (comma-separated)",
  "testing.admin.tokenIdsHint": "e.g. ECT0000000001-1, ECT0000000002-1",
  "testing.admin.tokenIdsRequired": "Enter at least one Token ID",
  "testing.admin.deactivationReason": "Deactivation Reason",
  "testing.admin.bypassAuthServer": "Bypass auth server (local deactivation only)",
  "testing.admin.bulkConfirm": "I confirm bulk deactivation of the listed tokens",
  "testing.admin.bulkConfirmRequired": "Confirm bulk deactivation by checking the box",
  "testing.admin.exportFormat": "Export Format",
  "testing.admin.daysToExport": "Days to Export",
  "testing.admin.statisticsDays": "Period (days)",
  "testing.admin.retentionDays": "Retention (days)",
  "testing.admin.dryRun": "Dry run (simulate only, no delete)",
  "testing.admin.dryRunLabel": "DRY RUN",
  "testing.admin.start": "Start Test",
  "testing.admin.success": "Test Successful",
  "testing.admin.failed": "Test Failed",
  "testing.admin.totalMatches": "Total Matches",
  "testing.admin.deactivated": "Deactivated",
  "testing.admin.failedCount": "Failed",
  "testing.admin.errors": "Errors",
  "testing.admin.healthStatus": "Overall Status",
  "testing.admin.database": "Database",
  "testing.admin.activeTokens": "Active Tokens",
  "testing.admin.exportedLogs": "Exported Logs",
  "testing.admin.exportSize": "Size",
  "testing.admin.totalLogs": "Total Logs",
  "testing.admin.errors24h": "Errors (24h)",
  "testing.admin.errorRate": "Error Rate",
  "testing.admin.deletedLogs": "Deleted Logs",
  "testing.admin.authServer": "Auth Server",
  "testing.admin.requests": "Requests",
  "testing.admin.avgResponse": "Avg Response",
  "apitools.nav": "API Tools",
  "apitools.title": "API Tools",
  "apitools.subtitle": "Interactive REST request builder against eTTS and connectors",
  "apitools.execute": "Execute",
  "apitools.executeHint": "Select an operation and execute to see the response",
  "apitools.includeStats": "Include stats (X-API-Stats)",
  "apitools.required": "Field \"{{field}}\" is required",
  "apitools.requiredOneOf": "Fill in at least one of: {{fields}}",
  "apitools.success": "Success",
  "apitools.error": "Error",
  "apitools.response": "Response",
  "apitools.requestHeaders": "Request Headers",
  "apitools.requestBody": "Request Body",
  "apitools.selectToken": "-- Select token --",
  "apitools.selectAuthServer": "-- Select auth server --",
  "apitools.any": "-- Any --",
  "apitools.validPin": "Valid PIN",
  "apitools.invalidPin": "Invalid PIN",
  "apitools.authorization": "Authorization",
  "apitools.auth.none": "None (anonymous)",
  "apitools.auth.adminJwt": "My admin JWT (cookie)",
  "apitools.auth.apikey": "API key",
  "apitools.auth.bearer": "Bearer token",
  "apitools.auth.customRaw": "Custom (verbatim)",
  "apitools.customHeaders": "Custom Headers",
  "apitools.headerName": "Header name",
  "apitools.headerValue": "Value",
  "apitools.addHeader": "Add header",
  "apitools.attrKey": "key (e.g. applicationId)",
  "apitools.attrValue": "value",
  "apitools.addAttr": "Add attribute",
  "apitools.sessionStale.title": "Session expired",
  "apitools.sessionStale.body": "Request was rejected by the security layer (typically a stale CSRF token after restart). Hard-refresh the page (Ctrl+Shift+R) and try again.",
  "apitools.stats.total": "Total",
  "apitools.stats.connector": "Connector",
  "apitools.stats.calls": "API calls",
  "apitools.stats.processing": "Processing",
  "apitools.stats.connectorCalls": "Connector calls (detail)",
  "apitools.genValidOtp": "Generate valid OTP",
  "apitools.genInvalidOtp": "Generate invalid OTP",
  "apitools.op.activateToken": "Activate Token",
  "apitools.op.listTokens": "List Tokens",
  "apitools.op.getToken": "Get Token",
  "apitools.op.instanceInfo": "Token state",
  "apitools.f.syncState": "Store the reported state on the token",
  "apitools.f.syncState.hint": "Unchecked, the state is only read from the auth server (GET /api/v1/tokens/{id}/instance-info). Checked, it is also stored on the token (POST /admin/api/v1/tokens/{id}/sync-state) and the response shows the old and the new state.",
  "apitools.op.deactivateToken": "Deactivate Token",
  "apitools.op.generateOtp": "Generate OTP",
  "apitools.op.verifyOtp": "Verify OTP",
  "apitools.f.authServerType": "Auth Server Type",
  "apitools.f.username": "Username",
  "apitools.f.otp": "OTP",
  "apitools.f.password": "Password",
  "apitools.f.activationGuid": "Activation GUID",
  "apitools.f.paatProfile": "PAAT Profile",
  "apitools.f.testTraceId": "Test Trace ID",
  "apitools.f.expiresInSeconds": "Expires In (s)",
  "apitools.f.expiresInSeconds.hint": "Optional token TTL in seconds",
  "apitools.f.tags": "Tags",
  "apitools.f.tags.hint": "Comma-separated",
  "apitools.f.connectorAttributes": "Connector Attributes",
  "apitools.generate": "Generate",
  "apitools.f.pushIdentifier": "Push Identifier",
  "apitools.f.applicationId": "Application ID",
  "apitools.f.isMigration": "Migration",
  "apitools.f.deviceType": "Device Type",
  "apitools.f.activationMethod": "Activation Method",
  "apitools.f.appType": "App Type",
  "apitools.f.applicationName": "Application Name",
  "apitools.f.kbId": "KBID (client identifier)",
  "apitools.f.kbId.hint": "Fill in only when the username is not the KBID — the verification OTP is looked up by KBID",
  "apitools.f.sourceTokenId": "Source Token",
  "apitools.f.accessToken": "Access Token (override)",
  "apitools.f.accessToken.hint": "Empty = use the source token's stored token",
  "apitools.f.codeVerifier": "Code Verifier (override)",
  "apitools.f.codeVerifier.hint": "Empty = reuse the source token's PKCE verifier",
  "apitools.f.state": "State",
  "apitools.f.tag": "Tag",
  "apitools.f.tokenId": "Token",
  "apitools.group.token": "Tokens",
  "apitools.group.tx": "Transactions",
  "apitools.group.dr": "Device Replacement",
  "apitools.op.pendingTransactions": "Pending Transactions",
  "apitools.op.transactionDetail": "Transaction Detail",
  "apitools.op.approveTransaction": "Approve Transaction",
  "apitools.op.rejectTransaction": "Reject Transaction",
  "apitools.op.createDeviceReplacement": "Create Replacement",
  "apitools.op.processDeviceReplacement": "Process Replacement",
  "apitools.op.verifyActivation": "Verify Activation",
  "apitools.op.assembleSequences": "Assemble Sequences",
  "apitools.f.ippids": "IPPIDs",
  "apitools.f.ippids.hint": "Empty = auto-filled from token username",
  "apitools.f.status": "Status",
  "apitools.f.status.all": "0 — all",
  "apitools.f.transactionId": "Transaction ID",
  "apitools.f.transactionId.hint": "GUID for eChannels, operationId for eCobra",
  "apitools.f.limit": "Limit",
  "apitools.f.includeDetails": "Include details",
  "apitools.f.secureMessage": "Secure Message",
  "apitools.f.secureMessage.hint": "Base64 signed data",
  "apitools.f.passwordType": "Password type (signature)",
  "apitools.f.recognitionType": "Recognition Type",
  "apitools.f.mode": "Mode",
  "apitools.f.reason": "Reason",
  "apitools.f.sequences": "Sequences (JSON array)",
  "apitools.f.sequences.hint": "JSON array of QR sequences",
  "apitools.invalidJsonArray": "Invalid JSON array (must be non-empty)",
  "apitools.dr.nextStep": "Next step:",
  "apitools.dr.approve": "Approve",
  "apitools.dr.reject": "Reject",
  "apitools.dr.fillVerify": "Fill Verify Activation",
  "apitools.dr.fillAssemble": "Fill Assemble Sequences",
  "apitools.group.kbcaas": "KB CAAS",
  "apitools.op.kbCaasGetInstanceInfo": "Instance Info",
  "apitools.op.kbCaasEvaluateDevice": "Evaluate Device",
  "apitools.op.kbCaasInitContext": "Init Context",
  "apitools.op.kbCaasDictionaryLatest": "Dictionary — Latest",
  "apitools.op.kbCaasGetDictionary": "Dictionary — Get Version",
  "apitools.f.version": "Version",
  "apitools.dict.title": "Local Dictionary Cache",
  "apitools.dict.refresh": "Refresh",
  "apitools.dict.empty": "No cached dictionaries",
  "apitools.dict.version": "Version",
  "apitools.dict.fetchedAt": "Fetched At",
  "apitools.dict.size": "Size",
  "apitools.dict.view": "View",
  "apitools.group.privat": "Privat banka",
  "apitools.op.privatLogin": "Login (obtain Bearer token)",
  "apitools.op.privatInvalidateLogin": "Discard cached token",
  "apitools.f.forceLogin": "Force a fresh login",
  "apitools.f.forceLogin.hint": "Ignores the token held in memory and runs both steps again.",
  "apitools.privatToken.title": "Bearer token for Privat Mobile API",
  "apitools.privatToken.hint": "Without an access token no call to their API goes through. The server obtains one by itself for the admin tools; here you can see whether it holds one, and get it by hand.",
  "apitools.privatToken.held": "Token held",
  "apitools.privatToken.none": "No token",
  "apitools.privatToken.autoLoginOff": "Auto-login off",
  "apitools.privatToken.obtain": "Obtain token",
  "apitools.privatToken.refresh": "Obtain again",
  "apitools.privatToken.discard": "Discard",
  "apitools.privatToken.obtainedAt": "Obtained",
  "apitools.privatToken.validUntil": "Valid until",
  "apitools.privatToken.remaining": "{{seconds}} s left",
  "apitools.privatToken.source": "Source",
  "apitools.privatToken.estimated": "The validity is the Test Token Server's estimate — Privat Mobile API returns neither an expiry nor a refresh token. The token may stop working sooner; after a rejection (401) it is obtained again.",
  "apitools.privatToken.failed": "Login failed at step „{{step}}“",
  "apitools.pending.title": "Pending transactions ({{count}})",
  "apitools.pending.hint": "Read out by the Pending transactions operation. The buttons switch to the matching tab and pre-fill the parameters — you submit there, so the password choice and mode can still be changed.",
  "apitools.pending.refresh": "Refresh",
  "apitools.pending.refreshFailed": "Refreshing the queue failed",
  "apitools.pending.expiresAt": "Expires",
  "apitools.pending.message": "Message",
  "apitools.pending.detail": "Detail",
  "apitools.pending.approve": "Approve",
  "apitools.pending.reject": "Reject",
  "apitools.pending.noMessage": "The transaction carries no message to sign, so it cannot be approved. Try listing again with Include details switched on.",
  "kbcaasauth.title": "KB CAAS Authorization Workflows",
  "kbcaasauth.run": "Run",
  "kbcaasauth.copyToTx": "Copy to Authorize Transaction →",
  "kbcaasauth.continuation": "Continuation",
  "kbcaasauth.continue": "Continue",
  "kbcaasauth.cancel": "Cancel session",
  "kbcaasauth.cancelConfirm": "Confirm cancel?",
  "kbcaasauth.rosResult": "ROS Result",
  "kbcaasauth.retriesLeft": "Retries left",
  "kbcaasauth.expiresAt": "Expires at",
  "kbcaasauth.recoveryHint": "Recovery hint",
  "kbcaasauth.canRetry": "Can retry",
  "kbcaasauth.wf.activate": "Activate by KBK",
  "kbcaasauth.wf.login": "Login",
  "kbcaasauth.wf.ros": "Register ROS",
  "kbcaasauth.wf.authorize": "Authorize Transaction",
  "kbcaasauth.wf.sessions": "Sessions",
  "kbcaasauth.f.kbkToken": "KBK Token",
  "kbcaasauth.f.pinType": "PIN Type",
  "kbcaasauth.f.language": "Language",
  "kbcaasauth.f.note": "Note (optional)",
  "kbcaasauth.f.authSubject": "Auth Subject (KBID owner ident)",
  "kbcaasauth.f.msgToAuthData": "Data to sign — msgToAuth.data (JSON)",
  "kbcaasauth.f.scoringData": "Scoring data (JSON, optional)",
  "kbcaasauth.f.paatToken": "PAAT Token",
  "kbcaasauth.f.requestUri": "request_uri (from Register ROS)",
  "kbcaasauth.f.kbSessionId": "X-KB-Session-Id (from Register ROS)",
  "kbcaasauth.f.sessionId": "Session ID",
  "kbcaasauth.f.otp": "OTP",
  "kbcaasauth.f.oidcUrl": "OIDC result URL",
  "kbcaasauth.sessions.load": "Load sessions",
  "kbcaasauth.sessions.sessionId": "Session ID",
  "kbcaasauth.sessions.workflow": "Workflow",
  "kbcaasauth.sessions.status": "Status",
  "kbcaasauth.sessions.template": "Template",
  "kbcaasauth.sessions.lastStep": "Last step",
  "kbcaasauth.sessions.use": "Use",
  "kbcaasauth.sessions.empty": "No sessions",
  "echtools.nav": "eChannels Tools",
  "echtools.title": "eChannels Tools",
  "echtools.subtitle": "CSOB eChannels API console (21 operations + OAuth2)",
  "echtools.noConnector": "eChannels connector is not available in this build.",
  "echtools.baseUrl": "Base URL",
  "echtools.execute": "Execute Operation",
  "echtools.genUuid": "Generate UUID",
  "echtools.copy": "Copy",
  "echtools.selectTransaction": "-- Select transaction --",
  "echtools.cacheToken": "Cached token",
  "echtools.err.noCacheToken": "Load transactions first (List Requests) — cached token is missing.",
  "echtools.signature": "Signature",
  "echtools.oauth.title": "OAuth2 Token",
  "echtools.oauth.subject": "Subject (user ID)",
  "echtools.oauth.subject.hint": "Sent with every operation",
  "echtools.oauth.clientId": "Client ID",
  "echtools.oauth.scope": "Scope",
  "echtools.oauth.scope.hint": "Activation / Signing",
  "echtools.oauth.scope.activation": "Activation",
  "echtools.oauth.scope.signing": "Signing",
  "echtools.oauth.override": "Access token override",
  "echtools.oauth.override.hint": "When set, bypasses OAuth2 (Bearer)",
  "echtools.oauth.getToken": "Get Access Token",
  "echtools.oauth.expiresIn": "Expires in",
  "echtools.group.activation": "Activation",
  "echtools.group.authorization": "Authorization",
  "echtools.group.otp": "OTP",
  "echtools.group.profile": "Profile / IPPID",
  "echtools.group.deviceReplacement": "Device Replacement",
  "echtools.group.transaction": "Transaction",
  "echtools.group.displayPin": "Display PIN",
  "echtools.op.initActivation": "Init Activation",
  "echtools.op.getInstanceInfo": "Get Instance Info",
  "echtools.op.finishActivation": "Finish Activation",
  "echtools.op.processActivation": "Process Activation",
  "echtools.op.createAuthRequest": "Create Authorization",
  "echtools.op.confirmAuthRequest": "Confirm Authorization",
  "echtools.op.getAuthDetail": "Get Auth Detail",
  "echtools.op.getAuthDetailPost": "Get Auth Detail (POST)",
  "echtools.op.getAuthList": "List Requests",
  "echtools.op.receiveElbCache": "Receive ELB Cache",
  "echtools.op.receiveAuthStatus": "Receive Auth Status",
  "echtools.op.rejectAuthRequest": "Reject Authorization",
  "echtools.op.setOfflineStatus": "Set Offline Status",
  "echtools.op.verifyOtp": "Verify OTP",
  "echtools.op.validateOtp": "Validate OTP",
  "echtools.op.addIppid": "Add IPPID",
  "echtools.op.removeIppid": "Remove IPPID",
  "echtools.op.createReplacement": "Create Device Replacement",
  "echtools.op.processReplacement": "Process Device Replacement",
  "echtools.op.confirmTransaction": "Confirm Transaction",
  "echtools.op.displayPinToken": "Display PIN Token",
  "echtools.f.activationOtp": "Activation OTP",
  "echtools.f.activationGuid": "Activation GUID",
  "echtools.f.instanceId": "Instance ID",
  "echtools.f.reason": "Reason",
  "echtools.f.tokenId": "Token",
  "echtools.f.mobileSDKData": "Mobile SDK Data",
  "echtools.f.isMigration": "Migration",
  "echtools.f.message": "Message (base64)",
  "echtools.f.applicationId": "Application ID",
  "echtools.f.pushIdentifier": "Push Identifier",
  "echtools.f.processGuid": "Process GUID",
  "echtools.f.signId": "Sign ID",
  "echtools.f.transactionId": "Transaction ID",
  "echtools.f.requestTypeId": "Request Type ID",
  "echtools.f.device": "Device",
  "echtools.f.secureChannelMessageSignature": "Secure Channel Message Signature",
  "echtools.f.guid": "GUID",
  "echtools.f.pinType": "PIN Type",
  "echtools.f.usedDeviceAuthType": "Used Device Auth Type",
  "echtools.f.deviceType": "Device Type",
  "echtools.f.ippids": "IPPIDs (comma separated)",
  "echtools.f.deviceId": "Device ID",
  "echtools.f.otp": "OTP",
  "echtools.f.password": "Password",
  "echtools.f.requestStatusId": "Request Status ID",
  "echtools.f.errorCode": "Error Code",
  "echtools.f.newIppidIdToken": "New IPPID ID Token",
  "echtools.f.mobileSdkData": "Mobile SDK Data",
  "echtools.f.request": "Request (encrypted)",
  "echtools.f.identitiesToRemove": "Identities to remove (comma sep.)",
  "echtools.f.operationId": "Operation ID",
  "echtools.f.signature": "Signature",
  "echtools.f.additionalData": "Additional Data",
  "echtools.cache.title": "Transaction Cache",
  "echtools.cache.allStatuses": "All statuses",
  "echtools.cache.allTypes": "All types",
  "echtools.cache.type": "Type",
  "echtools.cache.status": "Status",
  "echtools.cache.expiration": "Expiration",
  "echtools.cache.detail": "Detail",
  "echtools.cache.loaded": "Loaded",
  "echtools.cache.notLoaded": "Not loaded",
  "echtools.cache.fetchDetail": "Fetch Detail",
  "echtools.cache.confirmValid": "Confirm (valid)",
  "echtools.cache.confirmInvalid": "Confirm (invalid)",
  "echtools.cache.reject": "Reject",
  "asymtools.nav": "Asym Requests",
  "asymtools.title": "Asym Requests",
  "asymtools.subtitle": "Issues a signed request, a signature, or both at once — sending it to the auth server is up to you",
  "asymtools.token": "Token",
  "asymtools.tokenPlaceholder": "Pick or type a Token ID",
  "asymtools.operation": "Operation",
  "asymtools.operationId": "Operation ID",
  "asymtools.operationIdHint": "Identifier returned by the previous device replacement step.",
  "asymtools.build": "Build request",
  "asymtools.running": "Building…",
  "asymtools.notSentHint": "The server only built the request. Sending it to the auth server is up to you.",
  "asymtools.copy": "Copy",
  "asymtools.copied": "Copied",
  "asymtools.group.tx": "Transactions",
  "asymtools.group.token": "Token and instance",
  "asymtools.group.dr": "Device replacement",
  "asymtools.group.auth": "Login",
  "asymtools.op.getPendingTransactions": "Pending transactions",
  "asymtools.op.getInstanceInfo": "Instance information",
  "asymtools.op.approveTransaction": "Approve transaction",
  "asymtools.op.rejectTransaction": "Reject transaction",
  "asymtools.op.deactivate": "Deactivate instance",
  "asymtools.op.createDeviceReplacement": "Create device replacement",
  "asymtools.op.processDeviceReplacement": "Process device replacement",
  "asymtools.op.login": "Login",
  "asymtools.sign.message": "Message from the auth server",
  "asymtools.sign.messageHint": "Base64-encoded encrypted message — a transaction's secureChannelMessage, or the login challenge.",
  "asymtools.sign.scoringFlags": "Scoring flags",
  "asymtools.sign.submit": "Sign",
  "asymtools.sign.decrypt": "Decrypt",
  "asymtools.tool": "Tool",
  "asymtools.tool.request": "Request envelope",
  "asymtools.tool.request.hint": "Builds the signed envelope a token would send to the auth server. For approving a transaction and for the second step of login the envelope alone is not enough — use Envelope with signature.",
  "asymtools.tool.approve": "Envelope with signature",
  "asymtools.tool.approve.hint": "The SDK's createApproveTransactionRequest: envelope, signature and additionalData in one call. Use it to approve a transaction, to finish login, and to authorize a payment.",
  "asymtools.tool.approve.submit": "Build and sign",
  "asymtools.tool.signature": "Signature only",
  "asymtools.tool.signature.hint": "Signs a message from the auth server and returns the signature with its matching additionalData. Take the envelope from the Request envelope tool.",
  "asymtools.tool.decrypt": "Decrypt",
  "asymtools.tool.decrypt.hint": "Shows the contents of a message from the auth server — what is actually being signed.",
  "asymtools.sign.scoringFlagsHint": "Bit 0 = rooted, bit 1 = biometric. Takes precedence over recognition type.",
  "asymtools.sign.recognitionType": "Recognition type",
  "asymtools.sign.recognitionTypeHint": "Used only when scoring flags are left empty. Note the SDK numbers this differently (None 0 / Password 1 / Biometric 2).",
  "asymtools.sign.recognitionType.unset": "Omit",
  "asymtools.sign.recognitionType.password": "0 — password",
  "asymtools.sign.recognitionType.biometrics": "1 — biometrics",
  "asymtools.sign.password": "Password",
  "asymtools.sign.passwordValid": "Valid",
  "asymtools.sign.passwordInvalid": "Deliberately wrong",
  "asymtools.sign.userPassword": "Password (override)",
  "asymtools.sign.userPasswordHint": "Optional. Empty = the password stored with the token is used. Ignored for a deliberately wrong password, which is why the field is hidden then.",
  "asymtools.warning": "Warning",
  "asymtools.nextCall": "Where this goes on the wire",
  "asymtools.nextCall.query": "Query parameters",
  "asymtools.nextCall.body": "Request body",
  "asymtools.nextCall.alternatives": "The same values also go here",
  "soaptools.nav": "SOAP Tools",
  "soaptools.title": "SOAP Tools",
  "soaptools.subtitle": "eCobra SOAP operations with request XML preview",
  "soaptools.endpoint": "Endpoint",
  "soaptools.noConnector": "SOAP connector is not available in this build.",
  "soaptools.health.checking": "Checking…",
  "soaptools.health.healthy": "Connected",
  "soaptools.health.unhealthy": "Not Available",
  "soaptools.health.refresh": "Refresh Health",
  "soaptools.execute": "Execute SOAP Request",
  "soaptools.executeHint": "Fill in the parameters and run the operation.",
  "soaptools.requestXml": "Request XML",
  "soaptools.response": "Response",
  "soaptools.opt.yes": "Yes",
  "soaptools.opt.no": "No",
  "soaptools.group.otp": "OTP Management",
  "soaptools.group.device": "Device Management",
  "soaptools.group.sms": "SMS Management",
  "soaptools.group.authorization": "Authorization",
  "soaptools.op.generateOtp": "Generate OTP",
  "soaptools.op.getUserOtp": "Get User OTP",
  "soaptools.op.getInstanceInfo": "Get Instance Info",
  "soaptools.op.getUserDeviceList": "Get User Device List",
  "soaptools.op.getUserSmsPhoneNumber": "Get SMS Phone Number",
  "soaptools.op.setUserSmsPhoneNumber": "Set SMS Phone Number",
  "soaptools.op.decryptSecureMessages": "Decrypt Secure Messages",
  "soaptools.op.authorizationChallenge": "Authorization — Challenge",
  "soaptools.op.authorizationProcess": "Authorization — Process",
  "soaptools.f.identity": "Identity",
  "soaptools.f.deviceOSType": "Device OS Type",
  "soaptools.f.reason": "Reason",
  "soaptools.f.sendSms": "Send SMS",
  "soaptools.f.device": "Device ID",
  "soaptools.f.deviceType": "Device Type",
  "soaptools.f.appVersionCode": "App Version Code",
  "soaptools.f.identities": "Identities (comma separated)",
  "soaptools.f.filterStatus": "Filter Status (optional)",
  "soaptools.f.smsPhoneNumber": "Phone Number",
  "soaptools.f.secureChannelMessage": "Secure Channel Message (Base64)",
  "soaptools.f.operationType": "Operation Type",
  "soaptools.f.hash": "Hash",
  "soaptools.f.title": "Title",
  "soaptools.f.signedDataFields": "Signed Data Fields (comma sep.)",
  "soaptools.f.signedDataLabels": "Signed Data Labels (comma sep.)",
  "soaptools.f.signId": "Sign ID",
  "soaptools.f.signature": "Signature (MAC Code)",
  "soaptools.f.signatureType": "Signature Type",
  "loadtest.nav": "Load Test Generator",
  "loadtest.title": "Load Test Generator",
  "loadtest.subtitle": "Generates a ZIP bundle (JMeter plan + identities + warmup)",
  "loadtest.section.scenario": "Scenario",
  "loadtest.section.identities": "Identities",
  "loadtest.section.load": "Load & Target",
  "loadtest.section.warmup": "Warmup",
  "loadtest.warmup.unavailable": "No warm-up provider is available in this build — the generated plan will not run (warm-up requires the eCobra SOAP connector).",
  "loadtest.warmup.available": "Warm-up available for: {{types}}",
  "loadtest.section.apiKey": "API Key",
  "loadtest.targetSystem": "Target System",
  "loadtest.scenario": "Scenario",
  "loadtest.warmupMode": "Warmup Mode",
  "loadtest.warmup.runtime": "Runtime (fresh OTP per iteration)",
  "loadtest.warmup.pregenerated": "Pre-generated (bake OTPs into CSV now)",
  "loadtest.source.list": "List (CSV)",
  "loadtest.source.pattern": "Pattern",
  "loadtest.identitiesCsv": "Identities (CSV)",
  "loadtest.identitiesCsv.hint": "One row per identity",
  "loadtest.usernamePrefix": "Username Prefix",
  "loadtest.startIndex": "Start Index",
  "loadtest.endIndex": "End Index",
  "loadtest.padWidth": "Pad Width",
  "loadtest.phonePattern": "Phone Pattern",
  "loadtest.password": "Password",
  "loadtest.paatProfile": "PAAT Profile",
  "loadtest.threads": "Threads",
  "loadtest.rampUp": "Ramp-up (s)",
  "loadtest.loops": "Loops",
  "loadtest.protocol": "Protocol",
  "loadtest.host": "Host",
  "loadtest.port": "Port",
  "loadtest.clientIdent": "Client Ident",
  "loadtest.systemId": "System ID",
  "loadtest.deviceOSType": "Device OS",
  "loadtest.reason": "Reason",
  "loadtest.sendSms": "Send SMS",
  "loadtest.setPhone": "Set Phone",
  "loadtest.embedApiKey": "Embed API key in bundle",
  "loadtest.apiKey": "API Key",
  "loadtest.generate": "Generate Bundle",
  "loadtest.generated": "Bundle generated, download started (etts-loadtest.zip).",
  "paat.title": "PAAT Profiles",
  "paat.subtitle": "Device-info profiles for eChannels activation",
  "paat.add": "Add Profile",
  "paat.bulkUpdate": "Bulk Update Versions",
  "paat.editTitle": "Edit PAAT Profile",
  "paat.deleteTitle": "Delete PAAT Profile",
  "paat.deleteConfirm": "Really delete profile \"{{id}}\"? Cannot delete a profile referenced by tokens.",
  "paat.default": "Default",
  "paat.setDefault": "Set as default",
  "paat.selectPlatform": "-- Select platform --",
  "paat.fillRequired": "Fill in all required fields",
  "paat.versionCode": "Version Code",
  "paat.apiLevel": "API Level",
  "paat.language": "Language",
  "paat.deviceModel": "Device Model",
  "paat.deviceName": "Device Name",
  "paat.deviceManufacturer": "Manufacturer",
  "paat.bulkHint": "Updates versions for all profiles of a platform. At least one version is required.",
  "paat.bulkNeedVersion": "Provide at least one version",
  "paat.bulkApply": "Apply",
  "paat.idPattern": "ID may contain only letters, digits, hyphen and underscore",
  "paat.idHint": "Letters, digits, hyphen, underscore",
  "paat.bulkConfirm": "Confirm & update",
  "paat.bulkConfirmSummary": "Update all {{platform}} profiles?",
  "paat.col.id": "ID",
  "paat.col.name": "Name",
  "paat.col.platform": "Platform",
  "paat.col.appVersion": "App Version",
  "paat.col.sdkVersion": "SDK Version",
  "paat.col.usage": "Usage",
  "paat.col.device": "Device",
  "paat.col.versionCode": "Version code",
  "paat.col.apiLevel": "API level",
  "paat.col.default": "Default",
  "tokens.col.tags": "Tags",
  "tokens.col.paat": "PAAT profile",
  "tokens.col.actions": "Actions",
  "tokens.filter.all": "All",
  "tokens.filter.clear": "Clear filters",
  "tokens.filter.usernamePlaceholder": "Search username…",
  "tokens.filter.tokenIdPlaceholder": "Search Token ID…",
  "tokens.filter.tagPlaceholder": "Search tag…",
  "tokens.results.count": "{{count}} token(s) found",
  "tokens.results.empty": "No tokens found.",
  "tokens.action.detail": "Open detail",
  "tokens.action.copyId": "Copy Token ID",
  "tokens.action.sync": "Sync state",
  "tokens.action.tags": "Edit tags",
  "tokens.action.expiration": "Expiration",
  "tokens.action.paat": "Change PAAT profile",
  "tokens.action.blocked.deleted": "Not available for a deleted token",
  "tokens.action.blocked.notActivated": "Token is not activated yet",
  "tokens.action.blocked.notActive": "Only for an active token",
  "tokens.action.changePassword": "Change password",
  "tokens.action.generateOtp": "Generate OTP",
  "tokens.pw.required": "Password is required.",
  "tokens.pw.old": "Old password",
  "tokens.pw.new": "New password",
  "tokens.pw.label": "Password",
  "tokens.otp.expiresAt": "Expires at",
  "tokens.field.password": "Password (PIN)",
  "tokens.field.pushIdentifier": "Push Identifier",
  "tokens.field.deviceFingerprint": "Device Fingerprint",
  "tokens.secrets": "Token Secrets (SDK)",
  "tokens.secret.encryptionSalt": "Encryption salt",
  "tokens.secret.passwordCommon": "Password (common)",
  "tokens.secret.secretPassword": "Password (secret)",
  "tokens.secret.asymTokenData": "AsymToken data",
  "common.close": "Close",
  "tokens.action.deactivate": "Deactivate",
  "tokens.action.waitingForAuthServer": "Waiting for the auth server. If it does not respond, this can take up to a minute.",
  "tokens.action.delete": "Delete",
  "tokens.deactivateConfirm": "Deactivate token {{tokenId}}? The auth server will be called.",
  "tokens.deleteConfirm": "Permanently delete token {{tokenId}}? This cannot be undone.",
  "tokens.tagsLabel": "Tags (comma-separated)",
  "tokens.expiration.clear": "Clear expiration",
  "tokens.expiration.ttlSeconds": "TTL in seconds (optional)",
  "tokens.expiration.ttlHint": "When set, takes precedence over the date — expiration = now + N seconds.",
  "tokens.paat.warning": "Changing the PAAT profile may change the token's platform (Android/iOS). Make sure it matches the real device.",
  "tokens.tab.overview": "Overview",
  "tokens.tab.activation": "Activation",
  "tokens.tab.device": "Device & keys",
  "tokens.sync.changed": "State synchronised: {{from}} → {{to}}",
  "tokens.sync.unchanged": "State unchanged ({{state}}) — the auth server reports the same as eTTS.",
  "tokens.sync.failed": "State synchronisation failed",
  "tokens.bulk.selected": "{{tokens}} selected",
  "tokens.bulk.allMatchingSelected": "All {{tokens}} tokens matching the filter selected",
  "tokens.bulk.selectAllMatching": "Select all {{total}} matching the filter",
  "tokens.bulk.clear": "Clear selection",
  "tokens.bulk.selectPage": "Select all on page",
  "tokens.bulk.selectRow": "Select token {{tokenId}}",
  "tokens.bulk.scope.ids": "Selected tokens: {{tokens}}",
  "tokens.bulk.scope.filter": "All tokens matching the filter: {{tokens}}",
  "tokens.bulk.blockedHint": "The state of {{count}} selected tokens does not allow this action — the server will skip them and report it in the summary.",
  "tokens.bulk.confirmUnderstand": "I understand this will affect {{tokens}} tokens and cannot be undone.",
  "tokens.bulk.start": "Run",
  "tokens.bulk.stop": "Stop",
  "tokens.bulk.stopped": "Stopped — {{processed}} of {{total}} processed. Changes already made remain.",
  "tokens.bulk.progress": "Processed {{processed}} / {{total}}",
  "tokens.bulk.summary.succeeded": "Succeeded",
  "tokens.bulk.summary.failed": "Failed",
  "tokens.bulk.summary.skipped": "Skipped",
  "tokens.bulk.summary.skippedHint": "Skipped tokens are those whose state did not allow the action, or that disappeared in the meantime.",
  "tokens.bulk.summary.errors": "Errors ({{count}})",
  "tokens.bulk.summary.detailsTruncated": "The list is truncated; the full one is in the application log.",
  "tokens.bulk.tagsMode": "Tag update mode",
  "tokens.bulk.tagsMode.REPLACE": "Replace the whole list",
  "tokens.bulk.tagsMode.ADD": "Add to existing",
  "tokens.bulk.tagsMode.REMOVE": "Remove from existing",
  "tokens.bulk.emptyTags": "Enter at least one tag.",
  "tokens.bulk.expirationRequired": "Enter a date or a TTL, or tick clear expiration.",
  "tokens.bulk.ttlHint": "Resolved once when the run starts — every token gets the same instant.",
  "tokens.bulk.deleteWarning": "Tokens will be deleted permanently, including key material. This cannot be undone.",
  "tokens.bulk.deactivateWarning": "The auth server is called for every token — with thousands of tokens this can take minutes.",
  "tokens.bulk.bypassAuthServer": "Do not call the auth server",
  "tokens.bulk.bypassAuthServerHint": "Tokens are marked deleted locally only. Fast and works when the server is unreachable, but the state will diverge from it.",
  "docs.title": "Help",
  "docs.subtitle": "eTTS documentation and guides",
  "docs.search.placeholder": "Search in help…",
  "docs.search.noResults": "Nothing found",
  "docs.nav.toggle": "Contents / navigation",
  "docs.toc.title": "On this page",
  "docs.notFound": "Page not found.",
  "docs.banner.notTranslated": "This page has not been translated yet — showing the Czech version.",
  "docs.switchToCzech": "Switch to Czech",
  "docs.locked.title": "This feature is not enabled in your license.",
  "common.edit": "Edit",
  "locale.label": "Language",
  "locale.title": "Interface language",
  "locale.subtitle": "The choice is saved to your account and also applies to text coming from the server.",
  "locale.cs": "Čeština",
  "locale.sk": "Slovenčina",
  "locale.en": "English",
  "locale.cs.short": "CS",
  "locale.sk.short": "SK",
  "locale.en.short": "EN",
  "locale.saveError": "Could not save the language. Please try again.",
  "feature.advertised.badge": "Coming soon",
  "feature.locked.badge": "Locked",
  "feature.advertised.title": "Coming soon",
  "feature.advertised.default": "This feature is being developed and will be available in a future release.",
  "feature.locked.title": "Feature is not in your license",
  "feature.locked.detail": "This feature is not enabled in your active license tier. Contact your license administrator or upgrade to unlock it.",
  "feature.plannedFor": "Planned for version {{version}}",
  "feature.viewLicense": "View license",
  "feature.id": "Feature identifier",
  "feature.hidden.title": "Page is not available",
  "feature.hidden.detail": "This part of the administration is not available in this installation.",
  "feature.backHome": "Back to overview",
  "general.version": "Application version",
  "settings.notifications": "Notifications",
  "notifications.markAllRead": "Mark all as read",
  "notifications.markRead": "Mark as read",
  "notifications.viewAll": "View all notifications",
  "notifications.unread": "Unread",
  "notifications.unreadOnly": "Unread only",
  "notifications.lastSeen": "last seen",
  "notifications.severity.INFO": "Info",
  "notifications.severity.WARNING": "Warning",
  "notifications.severity.ERROR": "Error",
  "notifications.category.APPLICATION_ERROR": "Application errors",
  "notifications.category.APPLICATION_ERROR.desc": "Unexpected failures — exceptions, unreachable infrastructure, scheduler errors. Auth-server rejections are excluded: those are legitimate test outcomes.",
  "notifications.category.MAINTENANCE": "Maintenance",
  "notifications.category.MAINTENANCE.desc": "Completed cleanup, database backup, deactivation of expired tokens.",
  "notifications.category.SECURITY": "Security",
  "notifications.category.SECURITY.desc": "Account lockout, failed sign-ins, role changes, directory unavailable.",
  "notifications.category.EXPIRY": "Expiration",
  "notifications.category.EXPIRY.desc": "Upcoming expiry of the license, the TLS certificate and tokens with a TTL.",
  "notifications.type.APPLICATION_ERROR_LOGGED.title": "Application error in {{logger}}",
  "notifications.type.APPLICATION_ERROR_LOGGED.message": "{{detail}}",
  "notifications.type.MAINTENANCE_AUTO_CLEANUP_COMPLETED.title": "Automatic cleanup completed",
  "notifications.type.MAINTENANCE_AUTO_CLEANUP_COMPLETED.message": "Deleted {{httpLogs}} communication logs, {{transactionLogs}} transaction logs and {{activationEvents}} activation events ({{durationMs}} ms).",
  "notifications.type.MAINTENANCE_CLEANUP_COMPLETED.title": "Cleanup completed",
  "notifications.type.MAINTENANCE_CLEANUP_COMPLETED.message": "Deleted {{deleted}} records.",
  "notifications.type.MAINTENANCE_BACKUP_COMPLETED.title": "Database backup completed",
  "notifications.type.MAINTENANCE_BACKUP_COMPLETED.message": "{{filename}} ({{size}}), {{durationMs}} ms.",
  "notifications.type.MAINTENANCE_TOKENS_EXPIRED.title": "Expired tokens deactivated",
  "notifications.type.MAINTENANCE_TOKENS_EXPIRED.message": "Deactivated {{count}} token(s) ({{durationMs}} ms).",
  "notifications.type.SECURITY_ACCOUNT_LOCKED.title": "Account {{username}} was locked",
  "notifications.type.SECURITY_ACCOUNT_LOCKED.message": "Locked after repeated failed sign-in attempts.",
  "notifications.type.SECURITY_LOGIN_FAILED.title": "Failed sign-in: {{username}}",
  "notifications.type.SECURITY_LOGIN_FAILED.message": "",
  "notifications.type.SECURITY_ROLES_CHANGED.title": "Roles changed for {{username}}",
  "notifications.type.SECURITY_ROLES_CHANGED.message": "New roles: {{roles}} (changed by {{actor}}).",
  "notifications.type.SECURITY_DIRECTORY_DOWN.title": "Directory service unavailable",
  "notifications.type.SECURITY_DIRECTORY_DOWN.message": "Directory sign-in did not go through — check connectivity.",
  "notifications.type.EXPIRY_LICENSE.title": "License expires in {{days}} day(s)",
  "notifications.type.EXPIRY_LICENSE.message": "Valid to {{validTo}}.",
  "notifications.type.EXPIRY_TLS_CERTIFICATE.title": "TLS certificate expires in {{days}} day(s)",
  "notifications.type.EXPIRY_TLS_CERTIFICATE.message": "Valid to {{notAfter}}.",
  "notifications.type.EXPIRY_TOKENS.title": "{{count}} token(s) expire within {{days}} days",
  "notifications.type.EXPIRY_TOKENS.message": "",
  "notificationSettings.title": "Notifications",
  "notificationSettings.subtitle": "What the channel escalates, how long notifications are kept and what was delivered.",
  "notificationSettings.categories": "Categories",
  "notificationSettings.categoriesHint": "A disabled category is never recorded. The severity floor filters out less important events within a category.",
  "notificationSettings.minSeverity": "Minimum severity",
  "notificationSettings.retentionDays": "Retention (days)",
  "notificationSettings.retentionHint": "Older notifications are removed by the hourly cleanup.",
  "notificationSettings.dedupWindow": "Merge window (minutes)",
  "notificationSettings.dedupHint": "The same event within the window only bumps a counter instead of adding a row.",
  "notificationSettings.reset": "Restore defaults",
  "common.saved": "Saved",
  "notifications.unreadCount": "Notifications — {{count}} unread",
  "notifications.category.TEST": "Test",
  "notifications.category.TEST.desc": "Manually triggered notifications for checking that the channel and the bell work.",
  "notifications.type.TEST_NOTIFICATION.title": "Test notification ({{severity}})",
  "notifications.type.TEST_NOTIFICATION.message": "Triggered manually from Settings → Notifications. For channel verification only.",
  "notificationSettings.testTitle": "Channel verification",
  "notificationSettings.testHint": "Creates a test notification so you can check the bell, the severity colours and delivery — without waiting for a real event.",
  "notificationSettings.createTest": "Create test notification",
  "notificationSettings.testCreated": "Created — check the bell",
  "versionNotice.title": "The application was updated to {{version}}",
  "versionNotice.subtitle": "You last worked with version {{previous}}. Here is what is new.",
  "versionNotice.viewAll": "View all changes",
  "versionNotice.dismiss": "Got it",
  "versionNotice.noChangelog": "There is no release-notes entry for this version yet. The full list is in the help centre.",
  "notifications.type.APP_VERSION_UPDATED.title": "Application updated to {{version}}",
  "notifications.type.APP_VERSION_UPDATED.message": "Previous version: {{previousVersion}}. The list of changes is in the help centre.",
  "scenarios.nav": "Scenarios",
  "scenarios.title": "Scenario generator",
  "scenarios.subtitle": "Declarative scenarios — run them live in eTTS, or export them for JMeter, SoapUI, Postman or k6.",
  "scenarios.catalog": "Catalog",
  "scenarios.pickOne": "Pick a scenario from the list on the left.",
  "scenarios.steps": "{{count}} steps",
  "scenarios.system": "Output system",
  "scenarios.mode": "Mode",
  "scenarios.export": "Download artifacts",
  "scenarios.exported": "Artifacts downloaded.",
  "scenarios.run": "Run in eTTS",
  "scenarios.notLoadSafe": "functional only",
  "scenarios.documentProblems": "Some documents could not be read:",
  "scenarios.keyTtl": "Key validity",
  "scenarios.issueKey": "Issue API key",
  "scenarios.keyIssued": "Key issued with scopes {{scopes}}, valid until {{expires}}. Shown only now.",
  "scenarios.keyUnresolved": "Scopes for steps {{steps}} could not be determined — the key may not cover them.",
  "perfMode.title": "Performance mode",
  "perfMode.subtitle": "Temporarily reduces communication logging so a load test cannot fill the database.",
  "perfMode.activeTitle": "Performance mode is running",
  "perfMode.activeDetail": "Communication logs are reduced to {{level}}.",
  "perfMode.levelLabel": "Logging level",
  "perfMode.durationLabel": "For how long",
  "perfMode.minutes": "{{count}} min",
  "perfMode.start": "Turn on",
  "perfMode.stop": "Turn off",
  "perfMode.remaining": "Remaining",
  "perfMode.startedBy": "Started by",
  "perfMode.suppressed": "Suppressed notifications",
  "perfMode.goToStats": "Server statistics",
  "perfMode.goToStatsAfterStart": "Go to server statistics after turning it on",
  "perfMode.autoExpiryHint": "The mode always expires on its own. Eight hours is the longest it can run.",
  "perfMode.queueHint": "Rows written before you turned it on are still being flushed from the queue.",
  "perfMode.level.FULL": "Full logging",
  "perfMode.level.NO_BODIES": "Without message bodies",
  "perfMode.level.ERRORS_ONLY": "Errors only",
  "perfMode.level.OFF": "Off",
  "perfMode.levelHint.FULL": "Everything is logged, message bodies included.",
  "perfMode.levelHint.NO_BODIES": "The row stays; only bodies and headers go — the bulky part.",
  "perfMode.levelHint.ERRORS_ONLY": "Recommended. Only failed calls are stored, but in full.",
  "perfMode.levelHint.OFF": "Nothing is stored. A failed test leaves no trace behind.",
  "perfMode.logsBanner": "Performance mode is running — communication logging is reduced ({{level}}).",
  "perfMode.statsBanner": "Performance mode is running. {{remaining}} left.",
  "perfMode.faster": "Refresh every 2 s",
  "notifications.type.MAINTENANCE_PERFORMANCE_MODE_STARTED.title": "Performance mode enabled",
  "notifications.type.MAINTENANCE_PERFORMANCE_MODE_STARTED.message": "Communication logging is reduced ({{level}}) for {{minutes}} min. Started by {{actor}}.",
  "notifications.type.MAINTENANCE_PERFORMANCE_MODE_ENDED.title": "Performance mode ended",
  "notifications.type.MAINTENANCE_PERFORMANCE_MODE_ENDED.message": "Communication logging is back to full detail. It ran {{minutes}} min and suppressed {{suppressed}} notifications.",
  "perfMode.sinceHint": "Running since {{since}} — older rows were written before it was turned on.",
  "perfMode.startedAt": "Running since",
  "perfMode.tooltipActive": "Communication logs: {{level}}. Running since {{since}}."
}
